import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "./featureInterface";
import {getFeatureEditPermission} from "../featuresFunctions";
import {featuresSetupShowMarkUpDownPopup} from "../featuresActions";
import SvgIcons from "../../Icons/SvgIcons";
import {MARK_UP_APPLY_TO_TYPES} from "../FeaturesSetupMarkPopup/markUpItemInterface";
// import {MARK_UP_APPLY_TO_TYPES} from "../FeaturesSetupMarkPopup/markUpItemInterface";

const FeaturesSetupFeatureContentMarkUpButton = (props) => {

  const {feature, applyToProps, featuresSetupShowMarkUpDownPopup} = props;

  if (!feature.markUpLogic || !Array.isArray(applyToProps)) {
    return null
  }

  const markUpLogic = JSON.parse(feature.markUpLogic);
  console.log("markUpLogic", markUpLogic);

  const isCaesMarkUp = typeof markUpLogic === "object" && (markUpLogic !== null) && !Array.isArray(markUpLogic)
    && ((markUpLogic.Retail && markUpLogic.Retail.Value && applyToProps.includes(MARK_UP_APPLY_TO_TYPES.retailPrice))
    || (markUpLogic.Cost && markUpLogic.Cost.Value && applyToProps.includes(MARK_UP_APPLY_TO_TYPES.cost))
    || (markUpLogic.Discount && markUpLogic.Discount.Value && applyToProps.includes(MARK_UP_APPLY_TO_TYPES.discount))
  );

  if (!isCaesMarkUp && (!Array.isArray(markUpLogic) || !markUpLogic.some(markUpItem => {
    return applyToProps.includes(markUpItem.applyTo) && (!feature.unlinkedData || (markUpItem.forUnlinkedCatId === +feature.unlinkedData.featureGroupCategory_id))
  }))) {
    return null
  }

  const markUpArrowsButtonClick = () => {
    featuresSetupShowMarkUpDownPopup(true)
  }

  return (
    <span className={"filters-button__icon filters-button__icon--mark-up-down"
      + (isCaesMarkUp ? " filters-button__icon--mark-up-down--disabled" : "")}
          onClick={isCaesMarkUp ? null : markUpArrowsButtonClick}>
      {SvgIcons.upDown}
    </span>
  )
};

FeaturesSetupFeatureContentMarkUpButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
  applyToProps: PropTypes.array.isRequired, // some property from MARK_UP_APPLY_TO_TYPES
}

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);

  return {
    canEdit,
  };
};

const mapDispatchToProps = {
  featuresSetupShowMarkUpDownPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureContentMarkUpButton)
